import { render } from "./ItemCategory.vue?vue&type=template&id=56e4ea19&scoped=true"
import script from "./ItemCategory.vue?vue&type=script&lang=js"
export * from "./ItemCategory.vue?vue&type=script&lang=js"

import "./ItemCategory.vue?vue&type=style&index=0&id=56e4ea19&scoped=true&lang=css"
import "./ItemCategory.vue?vue&type=style&index=1&id=56e4ea19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e4ea19"]])

export default __exports__